export const removeUndefined = (array: any[]) => {
  return array.filter((item) => item.src !== undefined && item.src !== '')
}
